import { FC } from "react";
import { Container } from "react-bootstrap";


import { NML_KEY } from "../../utils/_active_regions";
import { NML_DRIVING_TOGETHER, NML_JOURNEY, NML_STORY, NML_TESTIMONIALS } from "./_static";
import DiscoverJourney from "../Shared/RegionalPages/DiscoverJourney";
import DrivingTogether from "../Shared/RegionalPages/DrivingTogether";
import EmployeeLoves from "../Shared/RegionalPages/EmployeeLoves";
import Stories from "../Shared/RegionalPages/Stories";
import Testimonial from "../Shared/RegionalPages/Testimonial";

import banner_nml_1 from "../../assets/images/nml/banner_nml_1.webp";
import banner_nml_2 from "../../assets/images/nml/banner_nml_2.webp";
import banner_nml_3 from "../../assets/images/nml/banner_nml_3.webp";
import banner_nml_4 from "../../assets/images/nml/banner_nml_4.webp";
import banner_nml_5 from "../../assets/images/nml/banner_nml_5.webp";
import banner_nml_6 from "../../assets/images/nml/banner_nml_6.webp";
import ImageTile from "../Shared/Banner/RegionalBanner/ImageTile";

const images = [
    banner_nml_1,
    banner_nml_2,
    banner_nml_3,
    banner_nml_4,
    banner_nml_5,
    banner_nml_6
];

const Nml: FC = () => {
    return (
        <>
            <ImageTile images={images} region={NML_KEY} disableFloat={true} />
            <Container>
                <div id="discover-journey">
                    <DiscoverJourney  {...NML_JOURNEY} />
                </div>
                <DrivingTogether {...NML_DRIVING_TOGETHER} />
                <EmployeeLoves region={NML_KEY} />
                <Stories {...NML_STORY} />
                <Testimonial items={NML_TESTIMONIALS} />
            </Container>
        </>
    );
};
export default Nml;
